// extracted by mini-css-extract-plugin
export default {"hide-text":"Logo_hide-text__m3c-w","text":"Logo_text__6Wxxx"};